import {
    Component,
    Input
} from '@angular/core';
import { Editor } from '../../baseObjects/input';

@Component({
    selector: 'text-box',
    templateUrl: 'text-box.component.html',
    host: { 'class': 'text-box component' }
})
export class TextBoxComponent extends Editor {
}



// WEBPACK FOOTER //
// ./client-src/app/core/components/text-box/text-box.component.ts